import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import StarterPackage from "./pages/StarterPackage";
import BasicPackage from "./pages/BasicPackage";
import NewslettersPage from "./pages/NewslettersPage";
import AboutPage from "./pages/AboutPage";
import MediaStrategyPage from "./pages/MediaStrategyPage";
import BrandStorytellingPage from "./pages/BrandStorytellingPage";
import MediaProductionPage from "./pages/MediaProductionPage";
import PressAndPRPage from "./pages/PressAndPRPage";
import DigitalContentPage from "./pages/DigitalContentPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/packages/starter" element={<StarterPackage />} />
          <Route path="/packages/basic" element={<BasicPackage />} />
          <Route path="/newsletters" element={<NewslettersPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services/media-strategy" element={<MediaStrategyPage />} />
          <Route path="/services/brand-storytelling" element={<BrandStorytellingPage />} />
          <Route path="/services/media-production" element={<MediaProductionPage />} />
          <Route path="/services/press-and-pr" element={<PressAndPRPage />} />
          <Route path="/services/digital-content" element={<DigitalContentPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
